import $ from 'jquery';
import 'titon-toolkit';

export default function select(selector) {
  const $select = $(selector);

  if ($select.length) {
    $('select').inputSelect({
      arrowTemplate: '<i aria-hidden="true"></i>',
    });
  }
}



// WEBPACK FOOTER //
// ./js/core/components/select.js